import React, { useState, useEffect, useRef } from 'react';
import axios from '../../../axios/index';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// components
import ImageUploading from 'react-images-uploading';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-multi-date-picker';
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { profileValidate } from './profileValidate';

// Styles
import styles from "./MyAccount.module.css";
import Dstyles from "../DashboardFileManagement/DashboardFileManagement.module.css"
import archiveStyles from "../DashboardArchivedFiles/ArchiveDetail/ArchiveDetail.module.css"

// Image
import cameraUploadIcon from "./../../../assets/img/DashboardICons/cameraUploadBlue.svg";

const MyAccountInfo = (props) => {
    const [userProfileValue, setUserProfileValue] = React.useState([]);
    const [btnLoader, setBtnLoader] = useState(false)
    const [errors, setErrors] = useState({})
    const [cursor, setCursor] = useState('pointer');
    const [formValue, setFormValue] = useState({
        firstName: "",
        lastName: "",
        cardId: "",
        phone: "",
        email: "",
        aboutMe: "",
        education: "",
        address: "",
        CV: undefined,
        CVUpdated: false,
        dateChanged: false,
        landlinePhone: ""
    })
    const fileRef = useRef();

    const [birthDate, setBirthDate] = useState([])

    const changeProfileHandler = (userImage) => {
        setUserProfileValue(userImage);
    }

    const formChangeHandler = (e) => {
        if (e.target.name === "phone") {
            if (e.target.value === "" || e.target.value.match(/^[0-9]+$/)) {
                if (e.target.value.length <= 11) {
                    setFormValue((prev) => {
                        return { ...prev, [e.target.name]: e.target.value };
                    });
                }
            }
        } else if (e.target.name === "cardId") {
            if (e.target.value.length <= 10) {
                setFormValue((prev) => {
                    return { ...prev, [e.target.name]: e.target.value };
                });
            }
        }
        else {
            setFormValue((prev) => {
                return { ...prev, [e.target.name]: e.target.value };
            });
        }

    }

    const birthDateChangeHandler = (value) => {
        setBirthDate(value)
        setFormValue((prev) => {
            return { ...prev, dateChanged: true };
        });
    }

    useEffect(() => {
        setFormValue({
            ...formValue,
            firstName: props.userData?.name,
            lastName: props.userData?.family,
            phone: props.userData?.phoneNumber,
            landlinePhone: props.userData?.landlinePhone,
            email: props.userData?.email,
            cardId: props.userData?.nationalId,
            aboutMe: props.userData?.aboutMe,
            education: props.userData?.education,
            address: props.userData?.address,
            CV: props.userData?.cvImageName ? props.userData?.cvImageName : undefined,
            dateChanged: false
        });
        setBirthDate(props.userData?.birthDate)
    }, [props.userData])

    useEffect(() => {
        const setValidate = async () => {
            await setErrors(profileValidate(formValue, userProfileValue, birthDate))
        }
        setValidate()
    }, [formValue, userProfileValue, birthDate])

    return (
        <>
            <style>
                {
                    `
                    .rmdp-input {
                        color: #363636;
                        font-size: 16px;
                        border: 1px solid #e1e1e1;
                        border-radius: 100px;
                        height: auto;
                        padding: 11px 15px;
                        box-sizing: border-box;
                        transition: all 0.3s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                        box-shadow: none;
                        width: 100%;
                    }

                    .rmdp-input:focus {
                        border-color: #21409a;
                        box-shadow: none;
                    }
                    `
                }
            </style>

            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            <div dir="rtl" className={`text-right mx-4 px-2 mt-4 mb-3 d-inline-block`}>
                <div className="position-relative d-inline-block my-1" style={{ width: "max-content" }}>
                    <ImageUploading
                        value={userProfileValue}
                        onChange={changeProfileHandler}
                        dataURLKey="data_url"
                    >
                        {({ imageList, onImageUpload }) => (
                            <>
                                {
                                    imageList.length > 0
                                        ? imageList.map((item, index) => (
                                            <img key={index} className={`${styles.user_profile_image}`} src={item['data_url']} alt="user-profile" />
                                        ))
                                        : <img loading='lazy' className={`${styles.user_profile_image}`} src={`https://backdev.azrmelk.com/images/users/avatar/${props.avatarName?.replace("images/users/avatar/", "") || "avatar.png"}`} alt="user-profile" />
                                }

                                <div
                                    className={`${styles.camera_upload_icon_box} d-flex align-items-center justify-content-center position-absolute start-0`}
                                    role="button"
                                    onClick={onImageUpload}
                                >
                                    <img src={cameraUploadIcon} alt="camera-upload-icon" />
                                </div>
                            </>
                        )}
                    </ImageUploading>
                </div>

                <div className={`d-flex justify-content-between align-items-start flex-wrap my-4 py-3`}>
                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="firstName">نام</Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" id="firstName" name="firstName" value={formValue.firstName} onChange={formChangeHandler} />
                    </Form.Group>
                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="lastName">نام خانوادگی</Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" id="lastName" name="lastName" value={formValue.lastName} onChange={formChangeHandler} />
                    </Form.Group>
                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="birthDate">تاریخ تولد</Form.Label>
                        <DatePicker id="birthDate" name="birthDate" value={birthDate} onChange={birthDateChangeHandler} calendar={persian} locale={persian_fa} format="YYYY-MM-DD" />
                    </Form.Group>
                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="cardId">کد ملی </Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="number" id="cardId" name="cardId" value={formValue.cardId} onChange={formChangeHandler} />
                    </Form.Group>
                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="phone">شماره تلفن</Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="number" id="phone" name="phone" value={formValue.phone} onChange={formChangeHandler} />
                    </Form.Group>
                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="landlinePhone">شماره ثابت</Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="number" id="landlinePhone" name="landlinePhone" value={formValue.landlinePhone} onChange={formChangeHandler} />
                    </Form.Group>
                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="email">ایمیل</Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="email" id="email" name="email" value={formValue.email} onChange={formChangeHandler} />
                    </Form.Group>
                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="aboutMe">درباره من</Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" id="text" name="aboutMe" value={formValue.aboutMe} onChange={formChangeHandler} />
                    </Form.Group>
                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="education">تحصیلات</Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" id="education" name="education" value={formValue.education} onChange={formChangeHandler} />
                    </Form.Group>
                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="address">آدرس</Form.Label>
                        <Form.Control className={`${styles.form_control_input} shadow-none`} type="text" id="address" name="address" value={formValue.address} onChange={formChangeHandler} />
                    </Form.Group>
                    <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                        <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="education">رزومه</Form.Label>
                        <div className={`d-flex align-items-center justify-content-between px-3 pointer ${styles.form_control_input}`} onClick={() => fileRef.current.click()}>
                            <input
                                type="file"
                                name='CV'
                                onChange={changeHandler}
                                ref={fileRef}
                                hidden
                            />
                            <div className={formValue.CV === undefined ? styles.upload_text : styles.uploaded_text}>
                                {formValue.CV === undefined ? "فایل خود را بارگذاری کنید" : "فایل با موفقیت اضافه شد"}
                            </div>
                            <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M1.51884 1.26884C2.01113 0.776562 2.67881 0.5 3.375 0.5H14.625C15.3212 0.5 15.9889 0.776562 16.4812 1.26884C16.9734 1.76113 17.25 2.42881 17.25 3.125V12.875C17.25 13.5712 16.9734 14.2389 16.4812 14.7312C15.9889 15.2234 15.3212 15.5 14.625 15.5H12.75C12.3358 15.5 12 15.1642 12 14.75C12 14.3358 12.3358 14 12.75 14H14.625C14.9234 14 15.2095 13.8815 15.4205 13.6705C15.6315 13.4595 15.75 13.1734 15.75 12.875V3.125C15.75 2.82663 15.6315 2.54048 15.4205 2.3295C15.2095 2.11853 14.9234 2 14.625 2H3.375C3.07663 2 2.79048 2.11853 2.5795 2.3295C2.36853 2.54048 2.25 2.82663 2.25 3.125V12.875C2.25 13.1734 2.36853 13.4595 2.5795 13.6705C2.79048 13.8815 3.07663 14 3.375 14H5.25C5.66421 14 6 14.3358 6 14.75C6 15.1642 5.66421 15.5 5.25 15.5H3.375C2.67881 15.5 2.01113 15.2234 1.51884 14.7312C1.02656 14.2389 0.75 13.5712 0.75 12.875V3.125C0.75 2.42881 1.02656 1.76113 1.51884 1.26884ZM8.46967 5.96967C8.76256 5.67678 9.23744 5.67678 9.53033 5.96967L13.2803 9.71967C13.5732 10.0126 13.5732 10.4874 13.2803 10.7803C12.9874 11.0732 12.5126 11.0732 12.2197 10.7803L9.75 8.31066V20.75C9.75 21.1642 9.41421 21.5 9 21.5C8.58579 21.5 8.25 21.1642 8.25 20.75V8.31066L5.78033 10.7803C5.48744 11.0732 5.01256 11.0732 4.71967 10.7803C4.42678 10.4874 4.42678 10.0126 4.71967 9.71967L8.46967 5.96967Z" fill="#21409A" />
                            </svg>
                        </div>

                        <div className={`d-flex align-items-center justify-content-start position-relative mt-4`}>
                            <div className='d-flex flex-column align-items-start justify-content-start pe-2'>
                                <h5 className={Dstyles.card_main_detail_text1}>دانلود رزومه</h5>
                                <div className={`d-flex align-items-center justify-content-center ${archiveStyles.download_box}`}>
                                    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" className='ms-3'>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M0.769231 8.25806C1.19407 8.25806 1.53846 8.60468 1.53846 9.03226V12.795C1.53846 13.46 2.03556 14.0049 2.68081 14.0597C4.63373 14.2255 7.7196 14.4516 10 14.4516C12.2804 14.4516 15.3663 14.2255 17.3192 14.0597C17.9644 14.0049 18.4615 13.46 18.4615 12.795V9.03226C18.4615 8.60468 18.8059 8.25806 19.2308 8.25806C19.6556 8.25806 20 8.60468 20 9.03226V12.795C20 14.2514 18.9036 15.479 17.4485 15.6026C15.494 15.7685 12.3512 16 10 16C7.64875 16 4.50602 15.7685 2.55147 15.6026C1.09638 15.479 0 14.2514 0 12.795V9.03226C0 8.60468 0.344396 8.25806 0.769231 8.25806Z" fill="#21409A" />
                                        <path fillRule="evenodd" clipRule="evenodd" d="M9.45607 9.57969C9.75648 9.88204 10.2435 9.88204 10.5439 9.57969L13.6209 6.48292C13.9213 6.18058 13.9213 5.69039 13.6209 5.38805C13.3204 5.0857 12.8334 5.0857 12.533 5.38805L10.7692 7.16319V0.774194C10.7692 0.346619 10.4248 0 10 0C9.57517 0 9.23077 0.346619 9.23077 0.774194V7.16319L7.46701 5.38805C7.1666 5.0857 6.67955 5.0857 6.37915 5.38805C6.07875 5.69039 6.07875 6.18058 6.37915 6.48292L9.45607 9.57969Z" fill="#21409A" />
                                    </svg>
                                    <div className={archiveStyles.download_btn} onClick={handleDownload} style={{ cursor: cursor }}>
                                        دانلود رزومه
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Form.Group>
                </div>

                <div className="w-100 d-flex align-items-center justify-content-end">
                    {btnLoader ? (
                        <div className={styles.btn_loader_container}>
                            <div className={styles.btn_spinner}></div>
                        </div>
                    )
                        : (
                            <button className={`${styles.form_submit_btn} text-white border-0`} onClick={submitHandler}>ذخیره</button>
                        )
                    }
                </div>
            </div>
        </>
    )

    async function handleDownload() {
        setCursor("wait")
        try {
            const response = await axios({
                url: `https://backdev.azrmelk.com/api/Consultant/DownloadFile/${formValue.CV}`,
                method: 'GET',
                responseType: 'blob',
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.jpg');
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            notify("فایل یافته نشد", "error")
        }
        setCursor("pointer")
    };

    function submitHandler() {
        if (!Object.keys(errors).length) {
            notify("درحال اعمال تغییرات جدید", "success")
        } else {
            notify("!لطفا تمام فیلد هارا پرکنید", "error")
        }
    }

    function notify(text, type) {
        if (type === "success") {
            toast.success(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            formSendHandler()
        } else if (type === "success-posted") {
            toast.success(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            // console.log(errors)
            setBtnLoader(false)
        } else {
            toast.error(text, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            // console.log(errors)
            setBtnLoader(false)
        }
    };

    function changeHandler(e) {
        if (e.target.name === "CV") {
            setFormValue((prev) => {
                return { ...prev, CV: e.target.files[0], CVUpdated: true };
            });
        } else {
            setFormValue((prev) => {
                return { ...prev, [e.target.name]: e.target.value };
            });
        }
    }

    async function formSendHandler() {
        try {
            const p2e = s => s.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))
            setBtnLoader(true)
            var data = new FormData();
            data.append('Name', formValue.firstName);
            data.append('Family', formValue.lastName);
            data.append('Email', formValue.email);
            data.append('NationalId', formValue.cardId);
            data.append('Education', formValue.education);
            data.append('Address', formValue.address);
            data.append('AboutMe', formValue.aboutMe);
            data.append('PhoneNumber', p2e(formValue.phone));
            data.append('LandlinePhone', p2e(formValue.landlinePhone));
            if (formValue.dateChanged) {
                data.append('Birthdate', `${birthDate.year}/${birthDate.month.number}/${birthDate.day}`);
            } else {
                data.append('Birthdate', birthDate);
            }
            data.append('cvImageName', formValue.CV);
            data.append('Avatar', userProfileValue == "" ? props.avatarName : userProfileValue[0].file);

            const apiData = await axios.put(
                "Consultant/EditCurrent",
                data,
                {
                    headers: { authorization: "Bearer " + props.userToken },
                }
            );
            // console.log(apiData)
            notify("اطلاعات شما آپدیت شد", "success-posted")
            window.location.reload(false)
        } catch (error) {
            notify("خطایی رخ داد", "error")
        }
    }

}

export default MyAccountInfo